<script setup>
defineEmits([
  'click',
])
</script>
<template>
  <div :class="$style.wrapper">
    <div
      :class="$style.inner"
      @click="$emit('click', $event)"
    >
      <div
        :class="[$style.icon, $style.left]"
        hide-empty
      >
        <slot name="iconLeft" />
      </div>

      <slot />

      <div
        :class="[$style.icon, $style.right]"
        hide-empty
      >
        <slot name="iconRight" />
      </div>
    </div>
    <div :class="$style.underInput">
      <slot name="underInput" />
    </div>
  </div>
</template>

<style module>
.wrapper {
  position: relative;
  flex: 1;
  min-width: 0; /* To prevent child content in selectbox from growing the parent field beyond it's boundaries  */
}
.inner {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.5rem;
}
.underInput {
  position: relative;
}
.icon {
  position: absolute;
  top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 39px;
  width: 39px;
  color: var(--p-form-field-icon-color);
  &.left {
    left: 0;
  }
  &.right {
    right: 0;
  }
}
</style>
